export default __webpack_public_path__ + "static/wwc-image9-8772f4897c4a2d5fcd2d8a08e1c799aa.jpg";